<template>
  <v-row justify="center">
    <v-col cols="12" sm="8" md="7">
      <v-card class="home pa-5" outlined>
        <v-card-title class="text-h3 font-weight-bold card-title"
          >This Storefront Has Expired</v-card-title
        >
        <v-card-subtitle class="text-h4 pt-4"
          >This Minimart storefront needs an active subscription to open for
          business.</v-card-subtitle
        >
        <v-card-text>
          <p class="text-h6"
            >If you're the shop owner, please start your subscription by
            following the link below.
          </p>
          <div
            ><v-btn
              :to="{ name: ShopSettingsRoute, hash: '#subscription' }"
              class="white--text"
              depressed
              color="blue darken-1"
              x-large
              >Subscribe</v-btn
            >
          </div>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { GuestRoutes, MerchantRoutes } from '@/constants/RouteNames'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'ExpiredView',
  data: () => {
    return {
      fetchShopInterval: null,
      ShopSettingsRoute: MerchantRoutes.Manage.SHOP_SETTINGS,
    }
  },
  computed: {
    ...mapGetters('shop', ['getContactEmail', 'getIsShopDead']),
    ...mapGetters('auth', ['isCustomer']),
  },
  async created() {
    try {
      await this.fetchShop(true)
      this.fetchShopInterval = setInterval(() => this.fetchShop(true), 20000)
      if (this.isCustomer) {
        await this.logout()
      }
    } catch (error) {
      Promise.reject(error)
    }
  },
  methods: {
    ...mapActions('shop', ['fetchShop']),
    ...mapActions('auth', ['logout']),
  },
  beforeDestroy() {
    clearInterval(this.fetchShopInterval)
  },
  watch: {
    getIsShopDead: {
      handler(val) {
        if (!val) {
          this.$router.push({ name: GuestRoutes.HOME })
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="css" scoped>
.card-title {
  word-break: keep-all;
}
</style>
